import { useState, Fragment } from "react";

import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import Badge from "@mui/material/Badge";
import Divider from "@mui/material/Divider";
import MenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import LogoutVariant from "mdi-material-ui/LogoutVariant";
import AccountEditOutline from "mdi-material-ui/LockOutline";

import CustomAvatar from "@core/components/mui/avatar";

const BadgeContentSpan = styled("span")(({ theme }) => ({
  width: 8,
  height: 8,
  borderRadius: "50%",
  backgroundColor: theme.palette.success.main,
  boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
}));

const UserDropdown = (props) => {
  const { handleLogout, onClickPassword } = props;

  const value = localStorage.getItem("@userData");
  const userData = JSON.parse(value);

  const { username } = userData.data.user;

  const [anchorEl, setAnchorEl] = useState(null);

  const handleDropdownOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDropdownClose = () => {
    setAnchorEl(null);
  };

  const styles = {
    py: 1,
    px: 2,
    width: "100%",
    display: "flex",
    alignItems: "center",
    color: "text.secondary",
    textDecoration: "none",
    "& svg": {
      fontSize: "1.375rem",
      color: "text.secondary",
    },
  };

  const handleResetPassword = () => {
    onClickPassword();
    handleDropdownClose();
    setAnchorEl(null);
  };

  const onClickLogout = () => {
    handleLogout();
    handleDropdownClose();
    setAnchorEl(null);
  };

  return (
    <Fragment>
      <Badge
        overlap="circular"
        onClick={handleDropdownOpen}
        sx={{ ml: 1, mr: 1, cursor: "pointer" }}
        badgeContent={<BadgeContentSpan />}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <CustomAvatar
          skin="light"
          color={"secondary"}
          sx={{ fontSize: ".8rem", width: "2.4rem", height: "2.4rem" }}
        ></CustomAvatar>
      </Badge>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleDropdownClose()}
        sx={{ "& .MuiMenu-paper": { width: 220, mt: 2 } }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box sx={{ pt: 1, pb: 1, px: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Badge
              overlap="circular"
              badgeContent={<BadgeContentSpan />}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
            >
              <CustomAvatar
                skin="light"
                color={"secondary"}
                sx={{ fontSize: ".8rem", width: "2.4rem", height: "2.4rem" }}
              ></CustomAvatar>
            </Badge>
            <Box
              sx={{
                display: "flex",
                ml: 2,
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <Typography sx={{ fontWeight: 600, color: "text.secondary" }}>
                {username}
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontSize: "0.8rem", color: "text.disabled" }}
              >
                Admin
              </Typography>
            </Box>
          </Box>
        </Box>
        <Divider sx={{ mt: 0, mb: 1 }} />

        <MenuItem sx={{ p: 0 }}>
          <Box sx={styles} onClick={handleResetPassword}>
            <AccountEditOutline
              sx={{ mr: 2, fontSize: "1.375rem", color: "text.secondary" }}
            />
            Change Password
          </Box>
        </MenuItem>

        <MenuItem sx={{ p: 0 }} onClick={onClickLogout}>
          <Box sx={styles}>
            <LogoutVariant
              sx={{ mr: 2, fontSize: "1.375rem", color: "text.secondary" }}
            />
            Logout
          </Box>
        </MenuItem>
      </Menu>
    </Fragment>
  );
};

export default UserDropdown;
